<template>
  <div class="menber-dialog">
    <el-dialog title="需求信息详情" append-to-body :visible.sync="dialogVisible" :before-close="handleClose" width="700px">
      <el-form :inline="true" label-width="100px">
        <el-form-item label="托管人:" style="width: 350px">
          {{ currentItem.farmerName }}
        </el-form-item>
        <el-form-item label="托管人电话:">
          {{ currentItem.farmerPhone }}
        </el-form-item>
        <el-form-item label="接管人:" style="width: 350px">
          {{ currentItem.takeOverName }}
        </el-form-item>
        <el-form-item label="接管人电话:">
          {{ currentItem.companyPhone }}
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="210px">
        <el-form-item label="接管人统一社会信用代码:">{{
          currentItem.companyCode
          }}</el-form-item>
        <el-form-item label="托管类型:">
          {{ currentItem.orderType == 1 ? "全程托管" : "环节托管" }}
        </el-form-item>
        <!-- <el-form-item label="作物类型:"> -->
        <el-form-item label="种植作物:">
          {{ currentItem.cropCode }}
        </el-form-item>
        <el-form-item label="托管环节:">
          {{ currentItem.orderContent }}
        </el-form-item>

        <el-form-item v-if=" currentItem.orderType == 1" label="每季保底产量:">
          {{ currentItem.seasonYield }}
        </el-form-item>
        <!-- 新增首付款比例的展示 -->
        <el-form-item label="首付款比例:">
          {{ currentItem.downPayment }}
        </el-form-item>
        <el-form-item label="土地面积:">
          {{ currentItem.landArea }}亩
          <el-button type="primary" size="mini" @click="showLandMap" style="margin-left: 10px;">
            查看地块
          </el-button>
        </el-form-item>
        <el-form-item label="地址:">
          {{ currentItem.areaName }}
        </el-form-item>
        <el-form-item label="总价:">
          {{ currentItem.estimatePrice }}元
        </el-form-item>
        <el-form-item label="其他说明:">
          {{ currentItem.remark }}
        </el-form-item>
        <el-form-item label="产权凭证:">
          <p v-for="(item, index) in currentItem.pzzp" :key="index" class="pdfStyle">
            {{ item.name }}
            <i class="el-icon-download" title="下载" @click="download(item)"></i>
          </p>
        </el-form-item>
        <el-form-item label="现场照片:">
          <el-image style="width: 100px; height: 100px; margin-right:5px" :src="item"
            v-for="(item, index) in currentItem.xczp" :key="index" :preview-src-list="currentItem.xczp">
          </el-image>
        </el-form-item>
      </el-form>
      <!-- 农户清单展示表格 -->
      <div v-if="currentItem.farmerList && currentItem.farmerList.length" style="margin-top: 30px;">
        <h3 style="margin-bottom: 10px;">农户名单</h3>
        <el-table :data="currentItem.farmerList" border style="width: 100%;">
          <el-table-column prop="farmerNames" label="农户姓名" align="center" />
          <el-table-column prop="area" label="面积（亩）" align="center" />
          <el-table-column prop="idCard" label="身份证号" align="center" />
          <el-table-column prop="phoneNumber" label="联系方式" align="center" />
        </el-table>
      </div>
    </el-dialog>

    <!-- 查看地块弹窗 -->
      
    <el-dialog title="查看地块" append-to-body :visible.sync="landMapVisible" width="800px" :before-close="closeLandMap">
      <div class="land-map-content">
        <!-- 这里可以放置地图组件或地块信息 -->
        <ShowMap :polygon-data="landPolygon"></ShowMap>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { findOrderLand } from "@/api/add";
import ShowMap from "@/views/exchange/ShowMap";
export default {
  components: {
    ShowMap,
  },
  data() {
    return {
      dialogVisible: true,
      landMapVisible: false, // 控制地块弹窗显示
      baseUrl: window.globalUrl.BASE_API,
      currentItem: {
        farmerList: [

        ]
      },
      landPolygon: []
    };
  },
  mounted() { },
  computed: mapGetters(["userInfo"]),
  watch: {},
  methods: {
    // 初始化详情回显
    async init(obj) {
      console.log(JSON.parse(JSON.stringify(obj)), '查看获取的obj')
      let pzzp = [];
      if (obj.landCertificateUrl) {
        JSON.parse(obj.landCertificateUrl).forEach((item) => {
          pzzp.push({
            ...item,
            urlView: this.baseUrl + "admin/file/get?ossFilePath=" + item.url,
          });
        });
      }
      obj.pzzp = pzzp;
      let xczp = [];
      if (obj.livePhotos) {
        JSON.parse(obj.livePhotos).forEach((item) => {
          xczp.push(this.baseUrl + "admin/file/get?ossFilePath=" + item.url);
        });
      }
      obj.xczp = xczp;

      // 处理农户清单，过滤无效数据
      if (Array.isArray(obj.farmerList)) {
        obj.farmerList = obj.farmerList.filter(f => f.farmerNames && f.farmerNames.trim() !== '');
        // 对农户信息进行脱敏处理
        obj.farmerList = obj.farmerList.map(farmer => {
          return {
            ...farmer,
            // 姓名脱敏：只显示姓氏，名字用*代替
            farmerNames: this.desensitizeName(farmer.farmerNames),
            // 身份证脱敏：只显示前6位和后4位，中间用*代替
            idCard: this.desensitizeIdCard(farmer.idCard),
            // 手机号脱敏：只显示前3位和后4位，中间用*代替
            phoneNumber: this.desensitizePhone(farmer.phoneNumber)
          };
        });
      } else {
        obj.farmerList = [];
      }
      this.currentItem = obj;
      // console.log(obj);
    },
    // 返回
    back() {
      this.$emit("closeDialog2", false);
    },
    handleClose() {
      this.$emit("closeDialog2", false);
    },
    // 下载
    download(item) {
      const url = item.urlView;
      let dom = document.createElement("a");
      dom.style.display = "none";
      dom.href = url;
      dom.setAttribute("download", item.name);
      document.body.appendChild(dom);
      dom.click();
    },
    // 显示地块弹窗
    showLandMap() {
      // console.log('查看地块弹窗', this.currentItem)
      findOrderLand({ orderId: this.currentItem.orderId }).then(res => {
        // console.log("查询的地块信息", res)
        if (res.data.length > 0 && res.data[0]?.shape[0]?.length >= 3) {
          const tempPolygon = []
          res.data.forEach(item => {
            tempPolygon.push(item.shape[0])
          })
          this.landPolygon = tempPolygon
          this.landMapVisible = true;
        } else {
          this.$message({
            message: "暂未查询到地块数据",
            type: "warning",
          });
        }
      })
    },
    // 关闭地块弹窗
    closeLandMap() {
      this.landMapVisible = false;
    },
    // 脱敏处理方法
    // 姓名脱敏：只显示姓氏，名字用*代替
    desensitizeName(name) {
      if (!name) return '';
      if (name.length <= 1) return name;
      return name.charAt(0) + '*'.repeat(name.length - 1);
    },
    // 身份证脱敏：只显示前6位和后4位，中间用*代替
    desensitizeIdCard(idCard) {
      if (!idCard) return '';
      if (idCard.length < 10) return idCard;
      return idCard.substring(0, 6) + '********' + idCard.substring(idCard.length - 4);
    },
    // 手机号脱敏：只显示前3位和后4位，中间用*代替
    desensitizePhone(phone) {
      if (!phone) return '';
      if (phone.length < 7) return phone;
      return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form-item {
  margin-bottom: 0 !important;

  .el-input {
    width: 260px;
  }
}

/deep/.el-dialog__body {
  padding-left: 30px;
}

.pdfStyle {
  margin: 0;
  background-color: #f5f7fa;
  color: #409eff;
  margin-bottom: 4px;
  height: 32px;
  width: 90%;
  line-height: 32px;
  text-indent: 8px;

  i {
    cursor: pointer;
    float: right;
    font-size: 20px;
    margin: 6px;
  }
}

.land-map-content {
  width: 100%;
  height: 500px;
}
</style>
